import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Contacts } from "./Contacts";

function ContactsContainerComponent({ adviser }) {
    return <Contacts adviser={adviser} />;
}

ContactsContainerComponent.propTypes = {
    adviser: PropTypes.object
};

const mapStateToProps = state => ({
    adviser: state.adviser.adviser
});

export const ContactsContainer = connect(mapStateToProps)(ContactsContainerComponent);
